import { render, staticRenderFns } from "./ToolbarComponent.vue?vue&type=template&id=4bdd7abd&scoped=true"
import script from "./ToolbarComponent.vue?vue&type=script&lang=js"
export * from "./ToolbarComponent.vue?vue&type=script&lang=js"
import style0 from "./ToolbarComponent.vue?vue&type=style&index=0&id=4bdd7abd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd7abd",
  null
  
)

export default component.exports